import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchSnippetByName } from 'api/queries';
import { GraphQLSnippet } from 'modules/snippets/types';

export type FetchSnippetByNameQueryResponse = {
  fetchSnippetByName: GraphQLSnippet | null;
};

export const useSnippetByName = (name: string | null) => {
  const {
    data,
    error: didError,
    isLoading,
  } = useGraphql<FetchSnippetByNameQueryResponse>(fetchSnippetByName, {
    variables: { name },
    skip: !name?.length, // Skip query if no name is provided
  });

  const snippet = data?.fetchSnippetByName ?? null;

  return {
    snippet,
    didError,
    isLoading,
  };
};
